<template>
    <v-tabs
        background-color="white"
        color="dark"
        show-arrows="mobile"
        v-model="tabSettings">
        <v-tab href="#shipping-options">Shipping Options</v-tab>
        <v-tab href="#tab-other-settings">Other Settings</v-tab>
        <v-tab href="#tab-fallback-settings">Fallback Settings</v-tab>
        <v-tab href="#tab-company-location-mapping">Company & Location Mapping</v-tab>
        <v-tab-item value="shipping-options">
            <ShippingOptions :id="id" />
        </v-tab-item>
        <v-tab-item value="tab-fallback-settings">
            <FallbackSettings :id="id" />
        </v-tab-item>
        <v-tab-item value="tab-other-settings">
            <OtherSettings :id="id" />
        </v-tab-item>
        <v-tab-item value="tab-company-location-mapping">
            <CompanyLocationMapping :id="id" />
        </v-tab-item>
    </v-tabs>
</template>
<script>

import ShippingOptions from './shipping-options';
import FallbackSettings from './FallbackSettings';
import OtherSettings from './OtherSettings';
import CompanyLocationMapping from './settings/company-location-mapping';

export default {

    props: {
        id: { type: Number, default: null },
    },

    components: {
        ShippingOptions,
        FallbackSettings,
        OtherSettings,
        CompanyLocationMapping
    },

    computed: {

        integrationId() {
            return this.id
        }

    },

    data() {
        return {
            tabSettings: 'shipping-options',
        }
    }
}
</script>
